import { useState } from 'react';

export default function ContactPanel({ visible }) {
  const [form, setForm] = useState({ name: '', phone: '', interest: 'smartphone' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('http://localhost:8000/submit-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', phone: '', interest: 'smartphone' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('success');
    }
  };

  return (
    <div className={`contact-panel${visible ? ' visible' : ''}`}>
      <span className="panel-label">Get Connected</span>
      <h3>Request<br />Callback</h3>

      <form onSubmit={handleSubmit} autoComplete="off">
        {/* 2-col bento row — 4px gap */}
        <div className="bento-fields">
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Full Name"
            required
          />
          <input
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Phone No."
            type="tel"
            required
          />
        </div>

        <select name="interest" value={form.interest} onChange={handleChange}>
          <option value="smartphone">Smartphone</option>
          <option value="smartwatch">Smartwatch</option>
          <option value="fibre">Fibre Internet</option>
          <option value="bundle">Bundle Deal</option>
        </select>

        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending…' : 'Submit →'}
        </button>

        {status === 'success' && (
          <p className="success-msg">We'll be in touch. Welcome to Vodacom.</p>
        )}
        {status === 'error' && (
          <p className="error-msg">Something went wrong. Try again.</p>
        )}
      </form>
    </div>
  );
}
